import React from "react";

export default function NationIntelRealtimePlanner({ selectedEvent, eventCommanderSelectOptions = [] }) {
  return (
    <div className="events-card events-panel-shell">
      <div className="events-panel-header">
        <h4>Nation Intel Realtime Planner</h4>
        <span>Void/Frenzy cross-nation commander intelligence board.</span>
      </div>
      <p className="events-muted-text">
        Planner plugin active for {selectedEvent?.displayLabel || selectedEvent?.name || "this event"}.
      </p>
      <div className="events-table-wrap" style={{ marginTop: 12 }}>
        <table className="events-table">
          <thead>
            <tr>
              <th>Commander</th>
            </tr>
          </thead>
          <tbody>
            {eventCommanderSelectOptions.slice(0, 20).map((row) => (
              <tr key={row.id}>
                <td>{row.label}</td>
              </tr>
            ))}
            {!eventCommanderSelectOptions.length && (
              <tr>
                <td>No commanders available yet for this event scope.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

